import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ThemeView } from "./ThemeView";
import { ThemeViewStore } from "../../store/ThemeViewStore";
import { useStore } from "../../../../hooks";

export const ThemeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/theme/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ThemeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ThemeView themeViewStore={store} />
      </PageLayout>
    </div>
  );
});
